export * from './invoice.service';
import { InvoiceService } from './invoice.service';
export const APIS = [InvoiceService];
